import { render } from "./ModalImportDepartment.vue?vue&type=template&id=7fefaf38&scoped=true"
import script from "./ModalImportDepartment.vue?vue&type=script&lang=js"
export * from "./ModalImportDepartment.vue?vue&type=script&lang=js"

import "./ModalImportDepartment.vue?vue&type=style&index=0&id=7fefaf38&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fefaf38"]])

export default __exports__